module.exports = __webpack_public_path__ + "img/img_tg.8d5951fd.png";